var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path, _g, _path2, _path3, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareemExtraWashbag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12.9986,
    height: 17.1367,
    rx: 2,
    transform: "matrix(0.995721 0.0924065 -0.0945373 0.995521 14.2346 2)",
    fill: "#FF7D19"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.9989,
    height: 17.1363,
    rx: 2,
    transform: "matrix(0.996801 -0.0799237 0.0817708 0.996651 10.2469 5.57397)",
    fill: "#A4FF00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 12.9904,
    height: 17.1477,
    rx: 2,
    transform: "matrix(0.968249 -0.249986 0.255427 0.966828 7.08643 10.1729)",
    fill: "#291482"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 12.9742,
    height: 17.1696,
    rx: 2,
    transform: "matrix(0.910768 -0.412918 0.420839 0.907135 4 14.4739)",
    fill: "#FF8CF9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16.1728,
    y: 14.4043,
    width: 11.4726,
    height: 15.1229,
    rx: 1,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 17.216,
    y: 24.835,
    width: 4.17185,
    height: 3.65037,
    rx: 0.5,
    fill: "#FCEA25"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17.216,
    y: 20.1418,
    width: 4.17185,
    height: 3.65037,
    rx: 0.5,
    fill: "#A4FF00"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.216,
    y: 15.4475,
    width: 4.17185,
    height: 3.65037,
    rx: 0.5,
    fill: "#291482"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4321,
    y: 24.835,
    width: 4.17185,
    height: 3.65037,
    rx: 0.5,
    fill: "#F2F3F8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4321,
    y: 20.1418,
    width: 4.17185,
    height: 3.65037,
    rx: 0.5,
    fill: "#FF7D19"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4321,
    y: 15.4475,
    width: 4.17185,
    height: 3.65037,
    rx: 0.5,
    fill: "#FF8CF9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4760_52442",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 15,
    width: 3,
    height: 3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5542 15.7126L7.63517 15.2225L8.61542 17.3845L7.53445 17.8746L6.5542 15.7126Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4760_52442)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4061 16.9637L7.24244 15.6597C7.24128 15.6584 7.24006 15.6571 7.23878 15.656C7.13713 15.5501 6.98482 15.5174 6.85856 15.5746C6.69074 15.6507 6.62038 15.8586 6.70173 16.038C6.71878 16.0756 6.74149 16.1098 6.76927 16.1397C6.76999 16.1406 6.77077 16.1415 6.77157 16.1424L7.91334 17.4215C8.01353 17.5418 8.17692 17.5833 8.31107 17.5225C8.47889 17.4464 8.54923 17.2385 8.46789 17.0591C8.45254 17.0252 8.43245 16.994 8.40817 16.9662C8.4075 16.9653 8.40681 16.9645 8.4061 16.9637Z",
    fill: "#251B7D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33523 16.5866L8.6322 15.8143C8.63105 15.8131 8.62983 15.8119 8.62857 15.8108C8.52528 15.7056 8.3687 15.6747 8.23773 15.7341C8.06372 15.813 7.98833 16.0232 8.06968 16.2026C8.08672 16.2402 8.10963 16.2742 8.13779 16.3038C8.13855 16.3048 8.13934 16.3057 8.14019 16.3066L8.821 17.0541C8.92259 17.1737 9.09042 17.2132 9.22949 17.1502C9.40352 17.0713 9.4789 16.8611 9.39756 16.6817C9.38223 16.6479 9.36197 16.6167 9.33731 16.5891C9.33665 16.5882 9.33594 16.5874 9.33523 16.5866Z",
    fill: "#251B7D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4760_52442",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 14,
    width: 2,
    height: 2
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38821 14.8853L9.05343 14.5836L9.46815 15.4983L8.80293 15.7999L8.38821 14.8853Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4760_52442)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.23571 15.045C9.22472 15.0339 9.21275 15.0234 9.19838 15.0124C9.19693 15.011 9.19539 15.0097 9.19377 15.0084C9.19377 15.0084 9.18935 15.005 9.18092 14.9993C9.17865 14.9978 9.17635 14.9962 9.17414 14.9948C9.12868 14.9649 8.95912 14.8621 8.68618 14.7923C8.62489 14.7766 8.56267 14.7943 8.51964 14.8395C8.4769 14.8844 8.46106 14.9486 8.47724 15.011C8.5237 15.1904 8.61795 15.4311 8.71505 15.5358C8.71673 15.5376 8.71838 15.5392 8.72004 15.5407C8.73821 15.5626 8.75864 15.5823 8.78079 15.5994C8.88919 15.683 9.0298 15.6971 9.14497 15.6448C9.18281 15.6277 9.21792 15.6034 9.24822 15.572C9.31528 15.5026 9.35091 15.4095 9.34854 15.3097C9.34615 15.21 9.30609 15.116 9.23571 15.045Z",
    fill: "#251B7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareemExtraWashbag);
export default __webpack_public_path__ + "static/media/careem-extra-washbag.0c5f2a2844550ea6677a3b6934b681e2.svg";
export { ForwardRef as ReactComponent };